var _style, _polygon, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8161DF;}\n\t.st1{fill:none;}\n\t.st2{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12,0.8 15.2,0 17.6,2.3 20.9,3.2 21.7,6.4 24,8.8 23.3,12 24,15.2 21.7,17.6 20.9,20.9 17.6,21.7  15.2,24 12,23.3 8.8,24 6.4,21.7 3.2,20.9 2.3,17.6 0,15.2 0.8,12 0,8.8 2.3,6.4 3.2,3.2 6.4,2.3 8.8,0 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,9.3c0,0.1,0,0.1,0,0.2v0.1C7.4,9.5,7.4,9.4,7.4,9.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.5,7.9l-6-3.5c-0.2-0.1-0.4-0.1-0.5,0l-6,3.5C5.9,8,5.8,8.1,5.8,8.3v6.9c0,0.2,0.1,0.3,0.2,0.4l6,3.5 c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l6-3.5c0.2-0.1,0.2-0.3,0.2-0.4V8.3C18.8,8.1,18.7,8,18.5,7.9z M12.3,5.4l5,2.9l-5,2.9 l-5-2.9L12.3,5.4z M6.8,9.2l5,2.9v5.8l-5-2.9V9.2z M17.8,14.9l-5,2.9V12l5-2.9V14.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockchain);
export default __webpack_public_path__ + "static/media/icon-blockchain.8a8ec8adf5e829aca349ff8cba310a16.svg";
export { ForwardRef as ReactComponent };